// extracted by mini-css-extract-plugin
export default {"containerModal":"ModalOfBrand_containerModal__udO1n","section":"ModalOfBrand_section__w7bSl","rowButton":"ModalOfBrand_rowButton__zGLNc","button":"ModalOfBrand_button__KkEro"};